var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "single-item-images-wrapper",
      class: {
        "overlay-image-opened": _vm.showOverlay || _vm.showBackgroundOverlay,
      },
    },
    [
      _c("div", { staticClass: "single-item-images" }, [
        _c("div", { staticClass: "main-image position-relative" }, [
          _vm.topItemTags.length > 0
            ? _c("div", { staticClass: "position-absolute item-tags-top" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column text-center item-tags" },
                  _vm._l(_vm.topItemTags, function (tag) {
                    return _c(
                      "span",
                      { key: tag.selectionId, staticClass: "item-tag small" },
                      [
                        _vm._v(
                          "\n            " + _vm._s(tag.value) + "\n          "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "carousel slide",
              attrs: {
                id: "singleItemCarouselImages",
                "data-ride": "carousel",
                "data-interval": 5000,
              },
              on: {
                mouseenter: _vm.stopCarousel,
                mouseleave: _vm.startCarousel,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "position-relative mx-auto",
                  staticStyle: { "max-width": "fit-content" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "carousel-inner",
                      on: {
                        mousemove: _vm.handleMouseMove,
                        mouseleave: _vm.handleMouseLeave,
                      },
                    },
                    [
                      _vm._l(_vm.previewImages, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class: {
                              "carousel-item": true,
                              active: index === 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openOverlay(index)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "d-block w-100",
                              attrs: {
                                src: item,
                                alt: _vm.name,
                                loading: index === 0 ? "eager" : "lazy",
                                fetchpriority: "high",
                                loading: "lazy",
                                decoding: "async",
                              },
                            }),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.showHoverBox
                        ? _c("div", {
                            staticClass: "hover-box",
                            style: _vm.hoverBoxStyle,
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "carousel-control carousel-control-prev",
                  attrs: {
                    "data-target": "#singleItemCarouselImages",
                    "data-slide": "prev",
                    "aria-label": "Previous",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M15 18L9 12L15 6",
                          stroke: "#121926",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "carousel-control carousel-control-next",
                  attrs: {
                    "data-target": "#singleItemCarouselImages",
                    "data-slide": "next",
                    "aria-label": "Next",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M9 18L15 12L9 6",
                          stroke: "#121926",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ol",
                { staticClass: "carousel-indicators" },
                _vm._l(_vm.previewImages, function (_, index) {
                  return _c("li", {
                    key: index,
                    class: { active: index === 0 },
                    attrs: {
                      "data-target": "#singleItemCarouselImages",
                      "data-slide-to": index,
                    },
                  })
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _vm.showHoverBox
            ? _c("div", {
                staticClass: "zoom-image",
                style: {
                  backgroundImage: "url(" + _vm.selectedImage + ")",
                  ..._vm.zoomImageStyle,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.videoId
            ? _c(
                "a",
                {
                  staticClass: "video-preview",
                  attrs: {
                    href: "https://www.youtube.com/embed/" + _vm.videoId,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    "aria-label": "video preview",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "50",
                        height: "50",
                        viewBox: "0 0 64 64",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c(
                        "g",
                        { attrs: { filter: "url(#filter0_d_567_26611)" } },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "32",
                              cy: "28",
                              r: "24",
                              fill: "#f53d3d",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M39.7199 27.663C40.3236 28.0577 40.3236 28.9422 39.7199 29.3369L29.5473 35.9883C28.8821 36.4232 28 35.946 28 35.1514L28 21.8486C28 21.054 28.8821 20.5768 29.5472 21.0117L39.7199 27.663Z",
                          fill: "#ffffff",
                        },
                      }),
                      _vm._v(" "),
                      _c("defs", [
                        _c(
                          "filter",
                          {
                            attrs: {
                              id: "filter0_d_567_26611",
                              x: "0",
                              y: "0",
                              width: "64",
                              height: "64",
                              filterUnits: "userSpaceOnUse",
                              "color-interpolation-filters": "sRGB",
                            },
                          },
                          [
                            _c("feFlood", {
                              attrs: {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix",
                              },
                            }),
                            _vm._v(" "),
                            _c("feColorMatrix", {
                              attrs: {
                                in: "SourceAlpha",
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha",
                              },
                            }),
                            _vm._v(" "),
                            _c("feOffset", { attrs: { dy: "4" } }),
                            _vm._v(" "),
                            _c("feGaussianBlur", {
                              attrs: { stdDeviation: "4" },
                            }),
                            _vm._v(" "),
                            _c("feComposite", {
                              attrs: { in2: "hardAlpha", operator: "out" },
                            }),
                            _vm._v(" "),
                            _c("feColorMatrix", {
                              attrs: {
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
                              },
                            }),
                            _vm._v(" "),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_567_26611",
                              },
                            }),
                            _vm._v(" "),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_567_26611",
                                result: "shape",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "thumbnail-images justify-content-md-center justify-content-lg-start",
          },
          _vm._l(_vm.carouselImages, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "thumbnail-image overflow-hidden",
                class: { active: index === _vm.selectedIndex },
                attrs: {
                  "data-target": "#singleItemCarouselImages",
                  "data-slide-to": index,
                },
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    src: item,
                    alt: _vm.name,
                    loading: "lazy",
                    decoding: "async",
                  },
                }),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.bottomItemTags.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center flex-wrap text-center item-tags my-3",
            },
            _vm._l(_vm.bottomItemTags, function (tag) {
              return _c(
                "div",
                {
                  key: tag.selectionId,
                  staticClass:
                    "d-inline-flex align-items-center justify-content-center item-tag",
                },
                [
                  tag.selectionId == 2809
                    ? _c("img", {
                        directives: [
                          { name: "lazyload-img", rawName: "v-lazyload-img" },
                        ],
                        attrs: {
                          src: "",
                          "data-src":
                            "https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/hand-palm.png",
                          alt: tag.value,
                          loading: "lazy",
                          decoding: "async",
                          width: "20",
                          height: "20",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  tag.selectionId == 2810
                    ? _c("img", {
                        directives: [
                          { name: "lazyload-img", rawName: "v-lazyload-img" },
                        ],
                        attrs: {
                          src: "",
                          "data-src":
                            "https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/hand-tap.png",
                          alt: tag.value,
                          loading: "lazy",
                          decoding: "async",
                          width: "20",
                          height: "20",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  tag.selectionId == 2811
                    ? _c("img", {
                        directives: [
                          { name: "lazyload-img", rawName: "v-lazyload-img" },
                        ],
                        attrs: {
                          src: "",
                          "data-src":
                            "https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/wool.png",
                          alt: tag.value,
                          loading: "lazy",
                          decoding: "async",
                          width: "20",
                          height: "20",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  tag.selectionId == 2812
                    ? _c("img", {
                        directives: [
                          { name: "lazyload-img", rawName: "v-lazyload-img" },
                        ],
                        attrs: {
                          src: "",
                          "data-src":
                            "https://cdn02.plentymarkets.com/6wg68w8zahno/frontend/assets/icons/towel.png",
                          alt: tag.value,
                          loading: "lazy",
                          decoding: "async",
                          width: "20",
                          height: "20",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "small" }, [
                    _vm._v(_vm._s(tag.value)),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-center mb-2 mr-2 mt-1",
        },
        [
          _c("series-badge", { attrs: { "item-id": _vm.itemId } }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "button-overlay-background d-inline-flex ml-auto align-items-center",
              on: { click: _vm.openBackgroundOverlay },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    "aria-hidden": "true",
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    fill: "none",
                    viewBox: "0 0 24 24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "m3 16 5-7 6 6.5m6.5 2.5L16 13l-4.286 6M14 10h.01M4 19h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-2 small" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.multiLanguage.ProductBackgroundVariations) +
                    "\n      "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showOverlay
        ? _c(
            "div",
            { staticClass: "overlay-wrapper" },
            [
              _c("item-image-overlay", {
                attrs: {
                  visible: _vm.showOverlay,
                  "carousel-images": _vm.carouselImages,
                  "preview-images": _vm.previewImages,
                  "selected-index": _vm.selectedIndex,
                  name: _vm.name,
                },
                on: { "close-overlay": _vm.closeOverlay },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showBackgroundOverlay
        ? _c(
            "div",
            { staticClass: "overlay-wrapper" },
            [
              _c("item-background-overlay", {
                attrs: {
                  visible: _vm.showBackgroundOverlay,
                  "selected-image": _vm.previewImages[0],
                  name: _vm.name,
                },
                on: { "close-background-overlay": _vm.closeBackgroundOverlay },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }